export default __webpack_public_path__ + "static/media/icon-silo-volume.00a36b2f.svg";